import React, { useState } from "react";
import FuelForm from "~/visuals/organisms/Expenses/ExpenseForm/FuelTypeForm";
import { useWorkDayApi } from "~/WorkDayApi";
import Spinner from "~/components/spinner";
import { useLoadReceipt } from "../useLoadReceipt";
import { FuelExpense, FuelExpenseRate } from "~/gql/types";
import {
  BaseExpenseFormProps,
  DefaultValFunc,
  ExpensePageWrapper,
  UniqueInitVals,
} from "~/visuals/organisms/Expenses/ExpenseForm/ExpensePageWrapper";

type EditFuelProps = BaseExpenseFormProps & {
  expenseRate: FuelExpenseRate;
  expenseEntry: FuelExpense;
};

const EditFuelExpense: React.FC<EditFuelProps> = (props) => {
  const { expenseEntry, project } = props;

  const [imageId, setImageId] = useState<string | null>(
    expenseEntry?.receiptImageId ?? null
  );

  const { editFuelExpense } = useWorkDayApi();

  const [image, setImage] = useState<any>();

  useLoadReceipt({ image, setImage, expenseEntry });

  if (!image && expenseEntry.receiptImageId) {
    return <Spinner open={true} />;
  }

  const parseNum = (val: any) => (val ? parseFloat(val) : null);

  const editExpense = async (
    values: Record<string, any>,
    defaultVals: DefaultValFunc
  ) => {
    const res = await editFuelExpense({
      ...defaultVals(values),
      payerInformation: values?.payerInformation,
      odometer: parseNum(values?.odometer)!,
      receiptTotal: parseNum(values?.receiptTotal)!,
      companyVehicle: values?.companyVehicle ?? false,
      receiptImageId: imageId,
      quantity: parseNum(values?.quantity)!,
      vehicleNumber: values?.vehicleNumber,
      expenseId: expenseEntry.id,
      state: project?.location?.state!,
      county: project?.location?.county!,
      payableOverride: values?.payableOverride || null,
    });

    return res;
  };

  const uniqueInitVals: UniqueInitVals = [
    {
      payerInformation: expenseEntry.payerInformation,
      odometer: expenseEntry.odometer,
      receiptTotal: expenseEntry.receiptTotal,
      vehicleNumber: expenseEntry.vehicleNumber,
      quantity: expenseEntry.quantity,
      companyVehicle: expenseEntry.companyVehicle ?? false,
      receiptImage: image,
    },
  ];

  return (
    <ExpensePageWrapper
      {...{
        ...props,
        uniqueInitVals,
        handleSubmit: editExpense,
        expenseType: "Fuel",
        formType: "Edit",
      }}
    >
      <FuelForm {...props} setImageId={setImageId} />
    </ExpensePageWrapper>
  );
};

export default EditFuelExpense;
